import { Component, Inject, ElementRef, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ReglaBase } from 'app/main/models/regla-base.model';
import { Mandato } from 'app/main/models/mandato.model';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';


@Component({
  selector: 'app-dialog-box-add-node',
  templateUrl: './dialog-box-add-node.component.html',
  styleUrls: ['./dialog-box-add-node.component.scss']
})
export class DialogBoxAddNodeComponent {

  action: string;
  usuarioCtrl = new FormControl();
  filteredUsuarios: Observable<Usuario[]>;
  usuarios = [];
  LOCAL_DATA: any;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private service: UsersService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxAddNodeComponent>,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.dialogRef.disableClose = true;
    this.LOCAL_DATA = data.obj;

    this.action = data.action;
  }

  doAction(): void{
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if(this.LOCAL_DATA.palabrasClave == undefined){
      this.LOCAL_DATA.palabrasClave = [];
    }
    // Add our fruit
    if ((value || '').trim()) {
      var existe = this.findPalabraClave(value.trim());
      if(!existe)
        this.LOCAL_DATA.palabrasClave.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(categoria: any): void {
    const index = this.LOCAL_DATA.palabrasClave.indexOf(categoria);

    if (index >= 0) {
      this.LOCAL_DATA.palabrasClave.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    if(this.LOCAL_DATA.palabrasClave == undefined){
      this.LOCAL_DATA.palabrasClave = [];
    }

    const index = this.LOCAL_DATA.palabrasClave.indexOf(event.option.value);

    if (index == -1) {
      this.LOCAL_DATA.palabrasClave.push(event.option.value);
    }

    this.usuarioInput.nativeElement.value = '';
    this.usuarioCtrl.setValue(null);
    this.usuarioInput.nativeElement.blur();
  }

  findPalabraClave(name): boolean{
    var palabra = this.LOCAL_DATA.palabrasClave.indexOf(name)!=-1;
    return palabra;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }


}
